import { useI18n } from 'builder/hooks/useI18n'

import DocumentIcon from '../Icons/ResumeThumbnail.png'
import AttachIconBlue from '../Icons/AttachBlue.svg'
import { DocumentDeleteButton } from './DocumentDeleteButton'
import { DocumentThumbnailPlaceholder } from './DocumentThumbnailPlaceholder'
import { DocumentsListProps } from './types'

import {
  DocumentDownload,
  DocumentDownloadPlaceholder,
  DocumentsLineImg,
  DocumentsList as Container,
  DocumentsListItem,
  DocumentThumbnail,
  DropSection,
  DocumentIconContainer,
  AppliedDocIcon,
} from './styles'

export const DocumentsList = ({
  documents,
  isDragging,
  uploadingFile,
  uploadedDocumentType,
  handleDrop,
  handleDeleteDocument,
}: DocumentsListProps) => {
  const { i18n } = useI18n()

  return (
    <Container>
      {isDragging ? (
        <DropSection
          onDrop={event => handleDrop(event, uploadedDocumentType as 'resume' | 'cover_letter')}
          onDragOver={e => {
            e.preventDefault()
          }}
        >
          <DocumentsLineImg src={AttachIconBlue} />
          <span>{i18n.t('builder.job_search.auto_apply.action_buttons.file_attach')}</span>
        </DropSection>
      ) : (
        <>
          {documents?.map(({ id, documentFile }) => {
            if (!documentFile) return null
            return (
              <DocumentsListItem key={`resume-file-${id}`} href={documentFile.url} target="_blank">
                {uploadedDocumentType === 'auto_applied' && (
                  <DocumentIconContainer>
                    <AppliedDocIcon />
                  </DocumentIconContainer>
                )}
                <DocumentThumbnail
                  height={uploadedDocumentType === 'auto_applied' ? 48 : undefined}
                  src={DocumentIcon}
                />
                <DocumentDownload>{documentFile.filename}</DocumentDownload>
                {uploadedDocumentType !== 'auto_applied' && (
                  <DocumentDeleteButton
                    handleAction={() => handleDeleteDocument(id, uploadedDocumentType)}
                  />
                )}
              </DocumentsListItem>
            )
          })}
          {uploadingFile && uploadingFile.documentType === uploadedDocumentType && (
            <DocumentsListItem key="resume-file-placeholder">
              <DocumentThumbnailPlaceholder />
              <DocumentDownloadPlaceholder>{uploadingFile.file.name}</DocumentDownloadPlaceholder>
            </DocumentsListItem>
          )}
        </>
      )}
    </Container>
  )
}
